__webpack_require__.p = "/cloud/digital/registration/";